import { render } from "./VueProjectReaction.vue?vue&type=template&id=789196b0&ts=true&lang=pug"
import script from "./VueProjectReaction.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueProjectReaction.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/public/VueProjectReaction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "789196b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('789196b0', __exports__)) {
    api.reload('789196b0', __exports__)
  }
  
  module.hot.accept("./VueProjectReaction.vue?vue&type=template&id=789196b0&ts=true&lang=pug", () => {
    api.rerender('789196b0', render)
  })

}


export default __exports__